export const normalizeName = (value: string) => value.trim()

export const validateRequiredName = (value: string, message: string) => (normalizeName(value) === '' ? message : null)

export const validateMerchantRealName = (value: string) => {
  const name = normalizeName(value)

  if (name === '') {
    return '请输入姓名'
  }

  if (name.length < 2 || name.length > 30) {
    return '姓名长度应为2-30个字符'
  }

  return null
}
